// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteUserRequestModel from '../../model/delete-user-request-model';
import DeleteUserRequestDTO from '../dto/delete-user-request-dto';
import dtoSchema from '../schemas/delete-user-request-schema';

export default abstract class DeleteUserRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteUserRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteUserRequestDTO>): DeleteUserRequestModel;
  static toModel(dto: DeepPartial<DeleteUserRequestDTO> | undefined | null): DeleteUserRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteUserRequestDTO> | undefined | null): DeleteUserRequestModel | undefined {
    return dto ? new DeleteUserRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteUserRequestModel> | DeleteUserRequestModel): DeleteUserRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteUserRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteUserRequestModel, can not map to DeleteUserRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
